/*
 * @Author: Veto [关于蜜柚部分 路由]
 * @Date: 2021-06-16 16:08:20 
 * @Last Modified by: mikey.zhaopeng
 */

import Share from '../views/miyou/share';
import ShareXT from '../views/miyou/share_xt';
import DShare from '../views/miyou/dShare';
import OutDate from '../views/common/outdate';

import CallBack from '../views/miyou/callback';
import NewLiaoBan from '../views/miyou/newLiaoBan';
import NewLiaoBan32 from '../views/miyou/newLiaoBan32';
import MiYouTest from '../views/common/miyoutest';
import LiaoBanTest from '../views/common/liaobantest';


const router = {
    '/u-share': Share,
    '/u-share-xt': ShareXT,
    '/d-share': DShare,
    '/call-back': CallBack,

    '/out-date': OutDate,
    '/new-liaoban': NewLiaoBan,
    '/new-liaoban-32': NewLiaoBan32,
    '/miyou-test': MiYouTest,
    
    '/liaoban-test': LiaoBanTest,
};


export default router;